import React from "react";
import styles from "./style.module.css";
import { Layout } from "../Layout";
import { beige } from "assets/styleUtils";

interface Props {
  title: string;
  list: string[];
  color?: string;
  pdt?: number;
  style?: React.CSSProperties;
}

export default function GuideBox({
  title,
  list,
  color = beige,
  pdt = 40,
  style,
}: Props) {
  return (
    <Layout pdt={pdt} pdb={30} background={color} style={{ ...style }}>
      <div className={styles.guide}>
        <h4>{title}</h4>
        <ul>
          {list.map((item, index) => (
            <li
              key={index}
              dangerouslySetInnerHTML={{ __html: item }}
              style={{ fontSize: "14px", lineHeight: "150%" }}
            />
          ))}
        </ul>
      </div>
    </Layout>
  );
}
